import { useParams } from "react-router-dom";
import { FileDown } from "lucide-react";
import { BACKEND_URL } from "@/lib/api";
import { Logo } from "@/components/Logo";

export default function DescargaPublica() {
  const { token } = useParams();
  const url = `${BACKEND_URL}/api/documents/public/dl/${token}`;
  return (
    <div className="min-h-screen bg-[#FAF8F5] flex flex-col items-center justify-center p-6 text-center" data-testid="public-download">
      <Logo size={40} />
      <h1 className="font-display font-bold text-2xl mt-6">Tu documento FiinBridge está listo</h1>
      <p className="text-sm text-[#575757] mt-2 max-w-sm">Liga segura con vigencia de 7 días. Si expiró, pide a tu asesor que la reenvíe.</p>
      <a data-testid="public-download-button" href={url} target="_blank" rel="noreferrer" className="btn-brand mt-6"><FileDown size={16} /> Abrir / descargar</a>
    </div>
  );
}
